import type { ContentHref } from '@generalTypes/apiTypes';
import {
  selectContentItem,
  selectRawContentItem,
} from '@newStore/documentApi/documentApiSelectors';
import { booleanDiff } from '@newStore/documentUI/transformProposal/asideDiffText';
import { createTypedSelector } from '@newStore/genericHelpers';
import type { AsideChangeMessageSelector, EditAsideCheckbox } from '@nodeTypeConfig/configTypes';
import { get, isEqual } from 'lodash';

export const selectChangeMessageForCheckbox: AsideChangeMessageSelector<EditAsideCheckbox> =
  createTypedSelector(
    [
      (state, href: ContentHref) => selectContentItem(state, href),
      (state, href: ContentHref) => selectRawContentItem(state, href),
      (state, href: ContentHref, config) => config,
    ],
    (content, originalContent, config): string | null => {
      if (!config.property) {
        console.error('No property found for config', config);
        throw Error(`Can not convert ${config.property} to a string`);
      }

      const newValue = !!(get(content, config.property) ?? false);
      const oldValue = !!(get(originalContent, config.property) ?? false);

      if (isEqual(newValue, oldValue)) {
        return null;
      }

      const diffHtml = booleanDiff(newValue, oldValue);

      return diffHtml;
    },
  );
